class H17HomeCarousel extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.track = this.querySelector('[data-carousel-track]');
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-slide-to]')];
    this.pauseButton = this.querySelector('[data-pause]');
    this.status = this.querySelector('[data-slide-status]');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.index = 0;
    this.paused = this.reduced.matches;
    this.hovered = false;
    this.focused = false;
    this.classList.add('is-ready');
    this.querySelector('[data-carousel-controls]').hidden = this.slides.length < 2;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.hasAttribute('data-pause')) {
        this.paused = !this.paused;
        this.schedule();
      } else if (button.hasAttribute('data-step')) {
        this.show(this.index + Number(button.dataset.step), true);
      } else if (button.hasAttribute('data-slide-to')) {
        this.show(Number(button.dataset.slideTo), true);
      }
    }, { signal });
    this.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      if (event.target.matches('input, textarea, select')) return;
      event.preventDefault();
      this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
    }, { signal });
    this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
    this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
    this.addEventListener('focusout', (event) => {
      this.focused = this.contains(event.relatedTarget);
      this.schedule();
    }, { signal });
    this.addEventListener('touchstart', (event) => {
      this.touch = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
    }, { passive: true, signal });
    this.addEventListener('touchend', (event) => {
      if (!this.touch) return;
      const dx = event.changedTouches[0].clientX - this.touch.x;
      const dy = event.changedTouches[0].clientY - this.touch.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) this.show(this.index + (dx < 0 ? 1 : -1), true);
      this.touch = null;
    }, { passive: true, signal });
    document.addEventListener('visibilitychange', () => this.schedule(), { signal });
    this.reduced.addEventListener('change', () => {
      if (this.reduced.matches) this.paused = true;
      this.schedule();
    }, { signal });
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.findIndex(slide => slide.contains(event.target));
      if (index >= 0) { this.paused = true; this.show(index, true); }
    }, { signal });
    this.show(0);
  }
  show(index, manual = false) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.inert = !active;
      slide.setAttribute('aria-hidden', String(!active));
      this.dots[i]?.setAttribute('aria-current', String(active));
    });
    if (manual) this.status.textContent = `Slide ${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].dataset.title}`;
    this.schedule();
  }
  schedule() {
    clearTimeout(this.timer);
    const pauseText = this.paused ? 'Play' : 'Pause';
    if (this.pauseButton.textContent !== pauseText) this.pauseButton.textContent = pauseText;
    this.pauseButton.setAttribute('aria-label', this.paused ? 'Start slideshow' : 'Pause slideshow');
    if (this.paused || this.hovered || this.focused || document.hidden || this.slides.length < 2) return;
    this.timer = setTimeout(() => this.show(this.index + 1), 3000);
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    this.abort?.abort();
    this.abort = null;
  }
}
if (!customElements.get('h17-home-carousel')) customElements.define('h17-home-carousel', H17HomeCarousel);
